document.addEventListener('DOMContentLoaded', () => {
  $(document).on(`click`, `.faqlist-wrapper .faqlist-item .item-title`, function () {
    if ($(this).siblings('.item-desc').is(':hidden')) {
      $(this).find('.content-toggle-btn').html(`-`);
      $(this).addClass('active');
    } else {
      $(this).find('.content-toggle-btn').html('+');
      $(this).removeClass('active');
    }
    $(this).siblings('.item-desc').slideToggle();
  });
  $(`.faqlist-wrapper .faqlist-item .item-title`).eq(0).click();
});